import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import store from './store'
import axios from 'axios'

// 设置 baseURL，支持开发和生产环境的自动切换
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

// 创建 axios 拦截器，自动带上 token
axios.interceptors.request.use(
    (config) => {
      // 如果是登录请求，跳过 token 设置
      if (config.url.includes('/login')) {
        return config;  // 不添加 token
      }
      // 获取 Vuex 中存储的 token
      const token = store.getters.getUser.token;
      if ( token ) {
        // 如果 token 存在，设置请求头
        config.headers['Authorization'] = token;
      }
      return config;
    },
    (error) => {
      // 请求错误处理
      return Promise.reject(error);
    }
);

const app = createApp(App)



for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}


app.use(ElementPlus)
app.use(router)
app.use(store)
app.use(axios)
app.mount('#app')
